import { render } from "./DetailButton.vue?vue&type=template&id=3aec8d4c&scoped=true"
import script from "./DetailButton.vue?vue&type=script&lang=js"
export * from "./DetailButton.vue?vue&type=script&lang=js"

import "./DetailButton.vue?vue&type=style&index=0&id=3aec8d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aec8d4c"]])

export default __exports__